import React from "react";

const EarlyAccessCTA = ({ email }) => {
    const mailto = email || "hola@reformista.net";
    return (
        <section className="py-20 bg-white">
            <div className="max-w-5xl mx-auto px-6">
                <div className="max-w-xl mx-auto bg-gray-50 border border-gray-200 rounded-xl p-10 text-center shadow-sm">
                    <h2 className="text-2xl font-bold text-gray-900 mb-3">Solicitar acceso anticipado</h2>
                    <p className="text-gray-500 mb-6">
                        La plataforma está en acceso anticipado. Escríbenos y te damos acceso.
                    </p>
                    <a
                        href={`mailto:${mailto}`}
                        className="inline-block bg-brand-blue text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-800 transition-colors"
                    >
                        Contactar — {mailto}
                    </a>
                </div>
            </div>
        </section>
    );
};

export default EarlyAccessCTA;
